var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14890_7545)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.6098,
    height: 30.6607,
    transform: "translate(3.18457 2.40039)",
    fill: "#92ABFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7872 11.0002C16.1784 10.6959 15.5045 11.2768 15.7154 11.9238L17.0829 16.116C17.1216 16.2344 17.192 16.34 17.2865 16.4212C17.381 16.5024 17.4959 16.5562 17.6188 16.5766L23.0222 17.4771C23.3067 17.5248 23.3067 17.9336 23.0222 17.9813L17.6192 18.8818C17.4963 18.9022 17.3813 18.9559 17.2868 19.0372C17.1923 19.1184 17.1219 19.2239 17.0832 19.3424L15.7154 23.537C15.5041 24.1843 16.1784 24.7652 16.7872 24.4609L28.8797 18.4164C29.4449 18.1336 29.4449 17.3272 28.8797 17.0447L16.7872 11.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14890_7545",
    x: 0.913408,
    y: 0.697019,
    width: 43.1517,
    height: 35.2035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.567791
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.13558
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14890_7545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14890_7545",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLetter);
export default __webpack_public_path__ + "static/media/NewsLetter.f33d6078725d6ae5220ae50575e42d51.svg";
export { ForwardRef as ReactComponent };